import { useEffect } from "react";
import { api } from "@/lib/api";

function setMeta(attr, key, content, cms) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]${cms ? "[data-cms]" : ""}`);
  if (!content) {
    if (el && cms) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    if (cms) el.setAttribute("data-cms", "1");
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function applySiteMeta(site) {
  const title = site.meta_title || `${site.brand_name || "PropNest"} | Property management`;
  const desc = site.meta_description || site.hero_subtitle || "";
  document.title = title;
  setMeta("name", "description", desc);
  setMeta("name", "keywords", site.meta_keywords, true);
  setMeta("property", "og:title", title, true);
  setMeta("property", "og:description", desc, true);
  setMeta("property", "og:image", site.og_image, true);
  setMeta("name", "twitter:card", site.og_image ? "summary_large_image" : "summary", true);
  document.head.querySelectorAll("meta[data-cms-custom]").forEach((el) => el.remove());
  (site.custom_meta || []).forEach(({ name, content }) => {
    if (!name) return;
    const el = document.createElement("meta");
    el.setAttribute(/^(og|article|fb):/.test(name) ? "property" : "name", name);
    el.setAttribute("content", content || "");
    el.setAttribute("data-cms-custom", "1");
    document.head.appendChild(el);
  });
  if (site.favicon_url) {
    let link = document.head.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = site.favicon_url;
  }
}

export function SiteMeta() {
  useEffect(() => {
    api.get("/public/site").then((r) => applySiteMeta(r.data)).catch(() => {});
  }, []);
  return null;
}
